import { render, staticRenderFns } from "./addCard.vue?vue&type=template&id=01323b96&scoped=true"
import script from "./addCard.vue?vue&type=script&lang=js"
export * from "./addCard.vue?vue&type=script&lang=js"
import style0 from "./addCard.vue?vue&type=style&index=0&id=01323b96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01323b96",
  null
  
)

export default component.exports